module.exports = __webpack_public_path__ + "static/media/Invite-participants-URL-contest.6b2d5182.png";